import type { TypographyProps } from '@unifyapps/ui/components/Typography';
import type {
  CSSProperties,
  ForwardRefExoticComponent,
  PropsWithChildren,
  ReactElement,
  ReactNode,
  RefAttributes,
} from 'react';

export enum MarkdownWithExpandCollapseSlots {
  Expand = 'EXPAND',
  Collapse = 'COLLAPSE',
}

export type SlotProps = {
  name: MarkdownWithExpandCollapseSlots;
  id?: string;
  children: ReactNode;
};

export interface MarkdownWithExpandCollapseProps extends Pick<
  TypographyProps,
  'align' | 'variant' | 'weight' | 'style' | 'dir' | 'title'
> {
  text: string;
  children: ReactElement<SlotProps>[];
  className?: string;
  maxNumberOfLines: number;
  rootProps?: Record<string, unknown>;
  toggleMaskClassName?: string;
  toggleMaskStyle?: CSSProperties;
}

export function Slot(_: PropsWithChildren<SlotProps>): null {
  return null;
}

export type MarkdownWithExpandCollapseType = ForwardRefExoticComponent<
  MarkdownWithExpandCollapseProps & RefAttributes<HTMLDivElement>
> & {
  Slot: typeof Slot;
};
